// components/templateData.js

export const initialAssessmentPlanTopics = [
  {
    id: 1,
    title: 'Annual Exam'
  },
  {
    id: 2,
    title: 'Back Pain'
  },
  {
    id: 3,
    title: 'Chest Pain'
  },
  {
    id: 4,
    title: 'Knee Pain'
  },
  {
    id: 5,
    title: 'Lab Orders'
  },
  {
    id: 6,
    title: 'Nausea Vomiting'
  },
  {
    id: 7,
    title: 'Swallowing Difficulty'
  },
  {
    id: 8,
    title: 'URI'
  },
  {
    id: 9,
    title: 'UTI'
  },
  {
    id: 10,
    title: 'Varicose Veins'
  },
  {
    id: 11,
    title: 'Imaging order'
  }
];

export const initialAssessmentPlanTemplateText = {
  1: [
    {
      id: 1,
      text:
        'Patient is seen in medical clinic for annual exam and no significant finding noted',
      checked: false
    },
    {
      id: 2,
      text:
        'Diet and exercise',
      checked: false
    },
    {
      id: 3,
      text:
        'Screening lab tests recommended',
      checked: false
    },
    {
      id: 4,
      text:
        'Screening colonoscopy recommended',
      checked: false
    },
    {
      id: 5,
      text:
        'Screening mammogram recommended',
      checked: false
    }
  ],

  2: [
    {
      id: 1,
      text:
        'Recommend conservative treatment for back pain.',
      checked: false
    },
    {
      id: 2,
      text:
        'Physical therapy recommended.',
      checked: false
    },
    {
      id: 3,
      text:
        'Follow up if symptoms persist or worsen.',
      checked: false
    }
  ],

  3: [
    {
      id: 1,
      text:
        'Further cardiac evaluation recommended.',
      checked: false
    },
    {
      id: 2,
      text:
        'ECG and laboratory testing recommended.',
      checked: false
    }
  ],

  4: [
    {
      id: 1,
      text:
        'Rest and activity modification recommended.',
      checked: false
    },
    {
      id: 2,
      text:
        'Physical therapy may be considered.',
      checked: false
    }
  ],

  5: [
    {
      id: 1,
      text:
        'Routine laboratory studies ordered.',
      checked: false
    }
  ],

  6: [
    {
      id: 1,
      text:
        'Maintain adequate hydration.',
      checked: false
    },
    {
      id: 2,
      text:
        'Monitor symptoms and follow up if persistent.',
      checked: false
    }
  ],

  7: [
    {
      id: 1,
      text:
        'Further evaluation for swallowing difficulty recommended.',
      checked: false
    }
  ],

  8: [
    {
      id: 1,
      text:
        'Supportive treatment recommended.',
      checked: false
    }
  ],

  9: [
    {
      id: 1,
      text:
        'Urinalysis and urine culture recommended.',
      checked: false
    }
  ],

  10: [
    {
      id: 1,
      text:
        'Compression stockings recommended.',
      checked: false
    }
  ],

  11: [
    {
      id: 1,
      text:
        'Imaging study ordered as clinically indicated.',
      checked: false
    }
  ]
};